var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountryCn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H31V32H0V1Z",
    fill: "#D64B24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77506 8.07049L7.6428 10.7071H10.4129L8.17679 12.3091L9.01115 14.9456L6.77506 13.3103L4.53896 14.9456L5.4067 12.3091L3.17061 10.7071H5.9407L6.77506 8.07049ZM13.984 6.66876L13.9506 7.60325L14.7849 7.93699L13.8838 8.17062L13.8505 9.07173L13.3498 8.30411L12.4821 8.50436L13.0495 7.8035L12.5822 7.03588L13.4166 7.403L13.984 6.66876ZM17.0878 9.6391L16.6873 10.4401L17.3214 11.0742L16.4203 10.9407L16.0198 11.7417L15.8863 10.8406L14.9852 10.7071L15.7862 10.3066L15.6527 9.40547L16.2868 10.0396L17.0878 9.6391ZM16.1533 13.3103L16.4537 14.178H17.3548L16.6205 14.712L16.8875 15.5798L16.1533 15.0458L15.4191 15.5798L15.7194 14.712L14.9852 14.178H15.8863L16.1533 13.3103ZM13.984 16.1138L13.9172 17.0149L14.7849 17.3486L13.8838 17.5822L13.8171 18.4833L13.3498 17.7157L12.4487 17.9494L13.0495 17.2485L12.5489 16.4809L13.4166 16.8146L13.984 16.1138Z",
    fill: "#FBDC00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#D7D7D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryCn);
export default __webpack_public_path__ + "static/media/country-cn.9638b780.svg";
export { ForwardRef as ReactComponent };